<div class="modal-container">
    <div class="modal-header">
      <h4 class="modal-title pull-left">NOTE</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span class="modal-close-svg-button">
          <img [src]="closeImage | assetImageUrl" alt="Close">
        </span>
      </button>
    </div>
    <div class="modal-body">
        <div class="message-body">
            <img class="icon" [src]="'popup_exclamation_orange.svg' | assetImageUrl" alt="Alert">
            <p class="message-content">Entity Viewer can't be configured for the Multi-Plant/Plant alone.<br>Please choose one of the hierarchies for the selected option.</p>
        </div>
        <div class="close-button-container">
            <button class="close-button" (click)="modalRef.hide()">CLOSE</button>
          </div>
    </div>
  </div>

